import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from 'react-router-dom';

//Router
import {
    Route,
    Switch
} from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

//Controllers

import { headerSearch, tabs, unoTheme } from '../../../../assets/styles/unoTheme';

import { AccountAPI } from '../../../../API/account';
import MySelect from '../../../utils/MySelect';
import { MyTab, MyTabs } from "../../../utils/MyTabs";
import UnoButton from '../../../utils/UnoButton';
import { path } from "../../../utils/routesPaths";
import { applyMaskAmount, applyMaskAmountFreeDecimals, removeAccents } from '../../../utils/utils';
import { getRegimeOptions } from '../../../utils/accountRegimes';
import LossProvisionTab from './tabs/LossProvisionTab';
import ReturnsIPC14Tab from './tabs/ReturnsIPC14Tab';
import PrintIcon from '@material-ui/icons/Print';
import allActions from '../../../../actions';
import { checkUserIsRole, roles } from '../../../utils/user';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },
    bottomTabs: {
        height: '24px',
        width: '100%',
        background: unoTheme.menuContent,
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    flexCenterDiv: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: "12px",
        '& .ipc14-components': {
            display: 'flex',
            alignItems: 'center',
            gap: "12px",
        }
    },
});

export default function AccountingScreen(props) {

    const { selectedYearLossProvision, setOptionsYearsLossProvision } = props;

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const [tabValue, setTabValue] = useState(null);

    const [clientOnScreen, setClientOnScreen] = useState(undefined);
    const [selectedRegime, setSelectedRegime] = useState(0);

    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

        if (newValue == 0) {
            history.push(path.administrative.accounting.returnsIPC14)
        } else if (newValue == 1) {
            history.push(path.administrative.accounting.lossProvision)
        }

    };

    //IPCA14
    const [selectedAccount, setSelectedAccount] = useState(undefined);
    const [selectedAccountIndex, setSelectedAccountIndex] = useState(undefined);
    const [clientAccounts, setClientAccounts] = useState([]);
    const [ipca14Result, setIpca14Result] = useState();

    //LOSS PROVISION
    const [lossProvisionResult, setLossProvisionResult] = useState();
    const [footerLoss, setFooterLoss] = useState();


    const loadAccounts = async (clientId, segregation) => {

        console.log("segregation: ", segregation);
        const response = await AccountAPI.listClientAccountsByRegime(clientId, segregation == 0 ? null : segregation);

        console.log("RESPONSE: ", response)

        if (response.success) {

            const accs = response.body.rows;
            accs.unshift({
                clientId: clientId,
                id: 0,
            })
            setClientAccounts(accs)
            setSelectedAccountIndex(0);
            setSelectedAccount(accs[0]);

        } else {

            console.log("error: ", response.error)

        }
    }


    useEffect(() => {
        if (tabValue === 0) {
            loadAccounts(clientOn.client.id, selectedRegime); //segregação consolidada
        }
    }, [selectedRegime])

    useEffect(() => {
        console.log("selectedAccountIndex: ", selectedAccountIndex);
        if (clientAccounts.length) {
            const account = clientAccounts[selectedAccountIndex];
            console.log("account: ", account);
            setSelectedAccount(account);
        }
    }, [selectedAccountIndex])


    //FIM IPC14

    const [searchText, setSearchText] = useState("");

    const delayedChange = (text) => {
        setTimeout(() => {
            setSearchText(text)
        }, 800)
    }

    function changeSearch(e) {

        delayedChange(removeAccents(e.target.value.toUpperCase()))
        clearTimeout(delayedChange);
    }

    function doReportLossProvision(infosLossProvision) {

        console.log("infosLossProvision: ", infosLossProvision);
        const totalLoss = infosLossProvision.reduce((sum, item) => sum + (item.provision ? item.provision : 0), 0);
        const totalLine = {
            fund: "TOTAL PROVISÃO DE PERDAS",
            cnpj: "",
            balance: "",
            var: "",
            provision: applyMaskAmount(totalLoss, true),
        }

        const lines = [];

        const theNovemberLine = {
            fund: "Nov/" + selectedYearLossProvision,
            cnpj: "",
            balance: "",
            var: "",
            provision: "",
        }

        lines.push(theNovemberLine);

        infosLossProvision.forEach(element => {

            //checando assteriscos de VaR
            let extraLegend = "";
            switch (element.varMode) {
                case "24m":
                    extraLegend = "³";
                    break;
                case "18m":
                    extraLegend = "⁴";
                    break;
                case "15m":
                    extraLegend = "⁵";
                    break;
                case "12m":
                    extraLegend = "⁶";
                    break;
                default:
                    break;
            }
            lines.push({
                fund: element.fund_name,
                cnpj: element.cnpj,
                balance: applyMaskAmount(element.balance_now, true),
                var: applyMaskAmountFreeDecimals(element.var, null, 6) + '%' + extraLegend,
                provision: applyMaskAmount(element.provision, true),
            });
        });

        lines.push(totalLine);

        footerLoss.forEach((el) => {
            lines.push(el);
        })

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: 'loss_provision',
            message: 'Gerando relatório...',
            reportData: {
                lines: lines,
                year: selectedYearLossProvision,
            }
        }))



    }

    const regimeOptions = useMemo(
        () => getRegimeOptions(clientOn, {
            includeConsolidated: true,
            consolidatedLabel: 'Consolidado',
        }),
        [clientOn])

    useEffect(() => {
        if (!clientOn?.client) return;
        if (!tabValue) {
            handleChangeTabValue(null, 0)
        }
        if (tabValue === 0) {
            loadAccounts(clientOn.client.id, null); //segregação consolidada
        }
    }, [tabValue])

    useEffect(() => {

        console.log("clientOn?.client?.id: ", clientOn?.client?.id);
        if (!clientOn?.client?.id) return;
        handleChangeTabValue(null, 0)
        loadAccounts(clientOn.client.id, null); //segregação consolidada

    }, [clientOn?.client?.id])


    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>

                <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="Retornos" />
                        <MyTab label="Provisão de perdas" />
                        {/* <MyTab label="Ajustes Patrimoniais" disabled /> */}
                        {/* <MyTab label="Impairment" disabled /> */}

                    </MyTabs>

                </div>


                <div className={classes.rightHeader}>

                    {/* <TextField
                        style={{ width: "170px", minWidth: "180px" }}
                        onChange={(event) => changeSearch(event)}
                        className={classes.inputSearch}
                        label="Buscar fundo..."
                        variant="outlined"
                        size="small" /> */}

                    {
                        tabValue === 0 && <div className='ipc14-components'>

                            <MySelect
                                value={selectedRegime}
                                onChange={(e) => setSelectedRegime(e.target.value)}
                                options={regimeOptions.map((row, index) => (
                                    <option key={'regimes-accounting-filter-' + index} value={row.value}>
                                        {row.name}
                                    </option>
                                ))}

                            />

                            <MySelect
                                customWidth={'200px'}
                                value={selectedAccountIndex}
                                // initblank={'true'}
                                onChange={(e) => setSelectedAccountIndex(e.target.value)}
                                options={clientAccounts.map((row, index) => (
                                    <option key={'account-ipc14-' + row.id} value={index}>
                                        {
                                            row.id === 0 ?
                                                "Todas as contas"
                                                :
                                                (row.agency ? 'Ag: ' + row.agency + " - " : "") + 'CC: ' + row.number_account + ' / ' + row.description
                                        }
                                    </option>
                                ))}

                            />
                        </div>

                    }

                    {/* {
                        tabValue === 1 &&

                        <UnoButton
                            style={{ marginRight: '16px' }}
                            size={'small'}
                            disabled={!enableGenerateLossProvisionYear}
                            type='primary'>
                            {"Gerar provisão " + (selectedYearLossProvision ? ("[" + selectedYearLossProvision + "]") : "")}
                        </UnoButton>
                    } */}

                    {

                        tabValue === 1 &&
                        <UnoButton
                            style={{ marginRight: '16px' }}
                            size={'small'}
                            onClick={() => doReportLossProvision(lossProvisionResult)}
                            type='primary'
                            disabled={!lossProvisionResult?.length}
                            startIcon={<PrintIcon />}>
                            {"Gerar relatório"}
                        </UnoButton>
                    }

                    {
                        tabValue === 0 && checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor, roles.manager]) &&
                        <UnoButton
                            style={{ marginRight: '16px' }}
                            size={'small'}
                            disabled={!ipca14Result?.length}
                            type='primary'
                            startIcon={<PrintIcon />}
                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                path: 'returnsFundsIpc14',
                                data: ipca14Result,
                                isGeneralPASEP: true,
                            }))}>
                            {"Relatório Geral"}
                        </UnoButton>
                    }

                </div>


            </div>
            <Switch className={classes.switch}>
                <Route path={path.administrative.accounting.returnsIPC14}>
                    <ReturnsIPC14Tab
                        selectedRegime={selectedRegime}
                        searchText={searchText}
                        selectedAccount={selectedAccount}
                        setIpca14Result={setIpca14Result} />
                </Route>
                <Route path={path.administrative.accounting.lossProvision}>
                    <LossProvisionTab selectedYearLossProvision={selectedYearLossProvision}
                        setOptionsYearsLossProvision={setOptionsYearsLossProvision}
                        setLossProvisionResult={setLossProvisionResult}
                        setFooterLoss={setFooterLoss} />
                </Route>
                {/* <Route path={path.administrative.demonstratives.funds}>
                    <DemonstrativeTab searchText={searchText} />
                </Route> */}

            </Switch>



        </div >
    );
}



